import React from 'react';

import { CategoryDashboard } from '../modules/audience-category-dashboard';

const sortingOptions = [
    {
        label: 'Sort by: Name',
        value: 'name',
        direction: 'asc',
    },
    {
        label: 'Sort by: Newest',
        value: '_created',
        direction: 'desc',
    },
    {
        label: 'Sort by: Last Updated',
        value: 'lastRefreshed',
        direction: 'desc',
    },
];

const SeasonalLayout = ({
    audienceSegments,
    onSearch,
    segmentCount,
    activeAudience,
    organizationId,
}) => {
    const linkToAudienceTab = {
        pathname: '/audiences/all',
        query: { audienceTab: 'pelmorex_data' },
        linkBackLabel: 'Pelmorex Data',
    };

    return (
        <CategoryDashboard
            audienceSegments={audienceSegments}
            onSearch={onSearch}
            segmentCount={segmentCount}
            activeAudience={activeAudience}
            organizationId={organizationId}
            sortingOptions={sortingOptions}
            description={
                'Combining seasonal visitation trends, digital content, and proprietary location intelligence, this segment identifies consumers demonstrating diverse interests and verified intent during key times of year.'
            }
            title={'Seasonal'}
            linkToAudienceTab={linkToAudienceTab}
            bannerImagePath={'/images/audience-segments/banners/seasonal-banner.png'}
        />
    );
};

export default SeasonalLayout;
